export default "__VITE_ASSET__DtCkKKOi__"